export default __webpack_public_path__ + "static/media/14_gaming.b686074e.png";